import {
  ORDER_STATUS,
  PAYMENT_CANCELLATION_STATUS,
} from '../../utils/constants';

/**
 * Reports whether an accepted cart cancellation requires cashier assistance.
 *
 * @param {Object} response - The parsed cart cancellation response.
 * @returns {boolean} Whether the response contains the valid assistance-required status pair.
 */
export const cartCancellationRequiresAssistance = (response) =>
  response?.order_status === ORDER_STATUS.VOID_PENDING &&
  response?.payment_cancellation_status ===
    PAYMENT_CANCELLATION_STATUS.ASSISTANCE_REQUIRED;
